import { Component, input, InputSignal } from '@angular/core';

/** Small tonal pill showing a numeric count (e.g. number of statuses in a column). */
@Component({
  selector: 'app-count-badge',
  standalone: true,
  styleUrl: './count-badge.component.scss',
  templateUrl: './count-badge.component.html',
})
export class CountBadgeComponent {
  public readonly count: InputSignal<number> = input.required<number>();
}
